// Central content + assets for the MEDISISTEM institutional site.
import { SCHIEBLER_PRODUCTS } from "./schiebler";
import { bendaggiCatalog } from "./bendaggi";

export const IMG = {
  heroLegs: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/5082db11025a55be1e358016110ed5a3931ee799f4a489084f0c8f59ccbc47e3.jpeg",
  lumaven: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/fc7105e97efc0840f1439ca795405d8800c4f8a8e85809839a16b945d6b67fbb.jpeg",
  schiebler: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/f1226206238f956a4c919d28c7fd86d8e51cf49c9b1b791bfb4ef228124a2125.jpeg",
  pressotherapy: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/29f2e9d2eed121c77a6278d12c3c977c375a077846b5bbca460d0b47621a3a64.jpeg",
  measure: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/1c17865b2836ddf084da226c4b2ece727062f032bda6ee36852cb1dcd3cd45f5.jpeg",
  goldpunkt: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/624bbb7c4d1dee7f379d92d450dc285e353228e9e0a5dfb34febc77ff66a8cc6.jpeg",
  doktus: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/771e221f6e5b239079b550fd96930da0c2e10852f3ab0cf97fe57809ba3d947c.jpeg",
  antitrombo: "https://static.prod-images.emergentagent.com/jobs/d4da042f-0010-47f4-9e7d-fb794eb96059/images/9d7e902ae57fa71182b8920594eded2a5a2d45818c76c2056d388013322748d5.jpeg",
  clinic: "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  consultation: "https://images.unsplash.com/photo-1666886573531-48d2e3c2b684?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  walking: "https://images.unsplash.com/photo-1591700151209-540626cf808c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  fabric: "https://images.unsplash.com/photo-1593250816874-8edf4f732edb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const CONTACT = {
  company: "Medisistem sas",
  legalName: "Medisistem snc di Mario de Peppo & C.",
  piva: "06546510634",
  pec: "medisistem@pec.it",
  address: "Via Giuseppe Bonito 19, Napoli",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Via%20Giuseppe%20Bonito%2019%2C%20Napoli",
  tel1: "081.7433033",
  tel2: "081.5920490",
  mobile: "339.1424138",
  email: "info@medisistem.it",
  web: "www.medisistem.it",
  payoff: "Affidabilità che si indossa.",
  since: "Dal 1986",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Chi Siamo", to: "/chi-siamo" },
  { label: "Soluzioni", to: "/soluzioni" },
  {
    label: "Prodotti",
    to: "/prodotti",
    children: [
      { label: "Calze terapeutiche e curative – SCHIEBLER", to: "/prodotti/schiebler" },
      { label: "Calze preventive e antitrombo – LUMAVEN", to: "/prodotti/lumaven" },
      { label: "Bendaggi", to: "/prodotti/bendaggi" },
      { label: "Pressoterapia", to: "/prodotti/pressoterapia" },
    ],
  },
  { label: "Il Metodo", to: "/il-metodo" },
  { label: "Servizi", to: "/servizi" },
  { label: "Canali", to: "/canali" },
  { label: "Contatti", to: "/contatti" },
];

export const STATS = [
  { value: "40+", label: "Anni di esperienza" },
  { value: "100%", label: "Specializzati" },
  { value: "Continua", label: "Assistenza" },
];

export const SOLUTIONS = [
  {
    id: "preventive",
    n: "01",
    title: "Calze Preventive",
    brand: "LUMAVEN",
    to: "/prodotti/lumaven",
    desc: "Sostegno leggero per le gambe di chi lavora a lungo in piedi o seduto, gravidanza e viaggi.",
    points: ["Comfort quotidiano", "Prevenzione del ristagno venoso", "Vestibilità discreta"],
  },
  {
    id: "terapeutiche",
    n: "02",
    title: "Calze Terapeutiche · Curative",
    brand: "SCHIEBLER",
    to: "/prodotti/schiebler",
    desc: "Compressione medicale certificata per il trattamento dell'insufficienza venosa e del linfedema.",
    points: ["STAR COTTON", "GOLDPUNKT KARAT", "DOKTUS"],
  },
  {
    id: "antitrombo",
    n: "03",
    title: "Calze Antitrombo",
    brand: "LUMAVEN",
    to: "/prodotti/lumaven/calza-antitrombo",
    desc: "Profilassi antitromboembolica per il paziente allettato o nel percorso post-operatorio.",
    points: ["Uso ospedaliero e domiciliare", "Prevenzione TVP", "Massima sicurezza"],
  },
  {
    id: "bendaggi",
    n: "04",
    title: "Bendaggi & Pressoterapia",
    brand: "Bendaggi · Pressoterapia",
    to: "/soluzioni#bendaggi",
    desc: "Bendaggi per la terapia compressiva e sistemi di pressoterapia sequenziale per il trattamento avanzato.",
    points: ["Bendaggi elastici", "Pressoterapia sequenziale", "Percorsi personalizzati"],
  },
];

// Le tre soluzioni "calze" — cuore dell'offerta.
// Solo soluzioni: nessun marchio, logo o elenco prodotti (visibili nelle pagine di dettaglio).
export const STOCKINGS = [
  {
    id: "terapeutiche",
    title: "Compressione terapeutica",
    subtitle: "Calze terapeutiche e curative",
    theme: "navy",
    featured: true,
    cat: "terapeutiche",
    to: "/prodotti?cat=terapeutiche",
    desc: "Compressione medicale certificata per il trattamento dell'insufficienza venosa cronica e del linfedema.",
  },
  {
    id: "preventive",
    title: "Compressione preventiva",
    subtitle: "Calze preventive",
    theme: "green",
    cat: "preventive",
    to: "/prodotti?cat=preventive",
    desc: "Sostegno leggero e discreto per le gambe di chi lavora a lungo in piedi o seduto, in gravidanza e in viaggio.",
  },
  {
    id: "antitrombo",
    title: "Antitrombo",
    subtitle: "Calze antitrombo",
    theme: "green-alt",
    cat: "antitrombo",
    to: "/prodotti?cat=antitrombo",
    desc: "Profilassi antitromboembolica per il paziente allettato e nel percorso post-operatorio, in sede e a domicilio.",
  },
];

// A completamento — formato compatto e discreto (categorie, non marchi)
export const COMPLEMENTS = [
  { id: "bendaggi", label: "Bendaggi", to: "/prodotti?cat=bendaggi", desc: "Bende per la terapia compressiva e il supporto: adesive, coesive, non adesive e altre tipologie." },
  { id: "pressoterapia", label: "Pressoterapia", to: "/prodotti?cat=pressoterapia", desc: "Sistemi di drenaggio linfatico sequenziale per gli arti." },
];

// Catalogo unico dei prodotti + filtri (soluzioni + macro-categorie SCHIEBLER).
export const PRODUCT_FILTERS = [
  { id: "tutti", label: "Tutti i prodotti" },
  { id: "terapeutiche", label: "Calze terapeutiche" },
  { id: "preventive", label: "Calze preventive" },
  { id: "antitrombo", label: "Calze antitrombo" },
  { id: "bendaggi", label: "Bendaggi" },
  { id: "pressoterapia", label: "Pressoterapia" },
  { id: "altri", label: "Altri dispositivi e accessori" },
];

// Card sintetiche SCHIEBLER generate dai dati completi (fonte unica: schiebler.js).
// Le calze/indumenti e i sistemi adattivi = "terapeutiche"; ortesi/tutori e accessori
// confluiscono in "Altri dispositivi e accessori". `subs` = filtro di secondo livello.
const SCH_THERAPEUTIC = ["calze-indumenti", "sistemi-adattivi"];
const SCHIEBLER_CATALOG = SCHIEBLER_PRODUCTS.map((p) => {
  const therapeutic = SCH_THERAPEUTIC.includes(p.macro);
  return {
    id: p.id,
    cats: therapeutic ? ["terapeutiche"] : ["altri"],
    subs: [p.macro],
    catLabel: p.category,
    name: p.name,
    brand: "SCHIEBLER",
    img: p.cover ?? null,
    short: p.title,
    to: `/prodotti/schiebler/${p.slug}`,
    featured: p.featured,
  };
});
const SCH_FEATURED = SCHIEBLER_CATALOG.filter((p) => p.featured);
const SCH_REST = SCHIEBLER_CATALOG.filter((p) => !p.featured);

export const CATALOG = [
  ...SCH_FEATURED,
  { id: "lum-linea-70", cats: ["preventive"], subs: ["linea-70", "gambaletto", "autoreggente", "monocollant", "collant-gestante", "collant-calibrato"], catLabel: "Calze preventive", name: "LUMAVEN Linea 70", brand: "LUMAVEN", img: null, short: "Vestibilità leggera e discreta: gambaletto, autoreggente, monocollant, collant gestante e collant calibrato.", to: "/prodotti/lumaven/linea-70" },
  { id: "lum-linea-140", cats: ["preventive"], subs: ["linea-140", "gambaletto", "autoreggente", "monocollant", "collant-gestante"], catLabel: "Calze preventive", name: "LUMAVEN Linea 140", brand: "LUMAVEN", img: null, short: "Sostegno e comfort con attenzione all'estetica: gambaletto, autoreggente, monocollant e collant gestante.", to: "/prodotti/lumaven/linea-140" },
  { id: "lum-calzini-comfort", cats: ["preventive"], subs: ["calzini-comfort"], catLabel: "Calze preventive", name: "LUMAVEN Calzini Comfort", brand: "LUMAVEN", img: null, short: "Calzini sobri e discreti, nelle versioni Comfort e Comfort Forte.", to: "/prodotti/lumaven/calzini-comfort" },
  { id: "lum-anti", cats: ["antitrombo"], subs: [], catLabel: "Calze antitrombo", name: "Calza antitrombo LUMAVEN", brand: "LUMAVEN", img: IMG.antitrombo, short: "Compressione graduata 18–21 mmHg con sistema autoreggente Soft Touch. Profilassi antitromboembolica secondo indicazione sanitaria.", to: "/prodotti/lumaven/calza-antitrombo" },
  ...bendaggiCatalog(),
  { id: "presso-advance", cats: ["pressoterapia"], subs: [], catLabel: "Pressoterapia", name: "Pressoterapia ADVANCE", brand: "LEM", img: IMG.pressotherapy, short: "Pressoterapia elettronica a 4 uscite con programmi sequenziali A/B.", to: "/prodotti/pressoterapia" },
  ...SCH_REST,
];

export const BRANDS = [
  {
    id: "lumaven",
    name: "LUMAVEN",
    badge: "Marchio di Proprietà Medisistem",
    theme: "green",
    to: "/prodotti/lumaven",
    desc: "La linea di proprietà Medisistem dedicata alla prevenzione e alla profilassi antitrombo.",
    pills: ["Preventive", "Antitrombo"],
  },
  {
    id: "schiebler",
    name: "SCHIEBLER",
    badge: "Distributore Esclusivo per l'Italia",
    ral: true,
    theme: "navy",
    to: "/prodotti/schiebler",
    desc: "Eccellenza tedesca nella calzetteria terapeutica. Medisistem è distributore esclusivo per l'Italia.",
    pills: ["STAR COTTON", "GOLDPUNKT KARAT", "DOKTUS"],
  },
];

export const BRANDS_SECONDARY = [
  { id: "bendaggi", name: "Bendaggi", to: "/prodotti/bendaggi", desc: "Bende per la terapia compressiva: adesive, coesive, non adesive, all'ossido di zinco e all'alginato." },
  { id: "pressoterapia", name: "Pressoterapia", to: "/prodotti/pressoterapia", desc: "Sistemi di pressoterapia sequenziale per il drenaggio linfatico degli arti." },
];

export const METHOD_STEPS = [
  { n: "01", title: "Consulenza", desc: "Ascoltiamo la tua storia clinica e le indicazioni del medico per capire il bisogno reale." },
  { n: "02", title: "Valutazione", desc: "Analizziamo la condizione venosa e linfatica per individuare la classe di compressione corretta." },
  { n: "03", title: "Misurazione", desc: "Rilevazione professionale delle circonferenze e delle lunghezze, punto per punto." },
  { n: "04", title: "Selezione", desc: "Scegliamo insieme il prodotto giusto tra le linee LUMAVEN e SCHIEBLER." },
  { n: "05", title: "Prova", desc: "Provi la calza in sede: verifichiamo vestibilità, comfort e corretta compressione." },
  { n: "06", title: "Assistenza", desc: "Ti seguiamo nel tempo con controlli, sostituzioni e supporto continuativo." },
];

export const METHOD_FLOW = [
  { title: "Prescrizione dello specialista", desc: "Il medico indica la classe di compressione adatta." },
  { title: "Misurazione professionale", desc: "Rileviamo circonferenze e lunghezze con precisione." },
  { title: "Scelta della taglia corretta", desc: "Individuiamo la misura esatta, non solo la classe." },
  { title: "Prova della calza", desc: "Verifichiamo vestibilità e comfort reali." },
  { title: "Comfort ed efficacia", desc: "Un dispositivo su misura migliora i risultati." },
];

export const TESTIMONIALS = [
  { name: "Maria R.", role: "Napoli", rating: 5, text: "Dopo anni di calze comprate a caso, la misurazione da Medisistem ha cambiato tutto: comode e finalmente efficaci." },
  { name: "Dott. Antonio S.", role: "Flebologo", rating: 5, text: "Indirizzo i miei pazienti con serenità: la misurazione è accurata e la prova della calza evita ogni errore di taglia." },
  { name: "Giuseppe L.", role: "Napoli", rating: 5, text: "Servizio a domicilio impeccabile. Personale competente e gentile, mi hanno seguito passo dopo passo." },
  { name: "Carla M.", role: "Portici", rating: 5, text: "Finalmente qualcuno che spiega e misura davvero. La differenza si sente ogni giorno che indosso le calze." },
];

export const WHY = [
  { title: "Dal 1986", desc: "Oltre quarant'anni dedicati esclusivamente alla terapia elasto-compressiva." },
  { title: "100% Specializzati", desc: "Un solo ambito, nessuna distrazione: solo compressione medicale." },
  { title: "Marchio di proprietà", desc: "LUMAVEN nasce e cresce con noi, controllo totale sulla qualità." },
  { title: "Distributore esclusivo", desc: "SCHIEBLER per l'Italia: eccellenza tedesca certificata." },
  { title: "Misurazione professionale", desc: "La misura giusta fa la differenza sull'efficacia terapeutica." },
  { title: "In sede o a domicilio", desc: "Ti raggiungiamo dove sei, con la stessa cura e precisione." },
  { title: "Prova della calza", desc: "Nessun acquisto al buio: si prova sempre prima." },
  { title: "Assistenza continuativa", desc: "Un punto di riferimento stabile, negli anni." },
];

export const SERVICES = [
  { title: "Consulenza specialistica", desc: "Un confronto dedicato per orientarti nella scelta terapeutica corretta, in linea con la prescrizione medica." },
  { title: "Misurazione professionale", desc: "Rilevazione precisa delle circonferenze e lunghezze per la calza su misura perfetta." },
  { title: "Prova della calza", desc: "Verifichiamo insieme vestibilità e comfort prima di ogni scelta definitiva." },
  { title: "Servizio in sede", desc: "Uno spazio dedicato nel cuore di Napoli, accogliente e riservato." },
  { title: "Servizio a domicilio", desc: "Per chi non può muoversi, portiamo competenza e strumenti a casa." },
  { title: "Assistenza", desc: "Supporto continuativo nel tempo: controlli, sostituzioni e consigli d'uso." },
];

export const VALUES = [
  { title: "Competenza", desc: "Un sapere costruito in oltre quarant'anni di pratica quotidiana." },
  { title: "Precisione", desc: "Ogni misura conta: lavoriamo con rigore metodico." },
  { title: "Fiducia", desc: "Relazioni durature con pazienti e professionisti sanitari." },
  { title: "Cura", desc: "La persona al centro, prima del prodotto." },
  { title: "Qualità", desc: "Solo prodotti certificati e materiali d'eccellenza." },
  { title: "Continuità", desc: "Un riferimento stabile, presente negli anni." },
];

export const TIMELINE = [
  { year: "1986", text: "Il socio fondatore inizia a operare nel settore, come rappresentante di un'azienda specializzata nella distribuzione di calze compressive." },
  { year: "1992", text: "Nasce Medisistem: l'esperienza maturata dal 1986 diventa un'azienda dedicata alla terapia elasto-compressiva." },
  { year: "1998", text: "Consolidamento del centro specializzato a Napoli e primi percorsi di misurazione su misura." },
  { year: "2005", text: "Ampliamento delle competenze cliniche e della rete di professionisti collaboratori." },
  { year: "2012", text: "Nasce LUMAVEN, il marchio di proprietà Medisistem per prevenzione e antitrombo." },
  { year: "2016", text: "Medisistem diventa distributore esclusivo per l'Italia del marchio SCHIEBLER." },
  { year: "2020", text: "Potenziamento del servizio a domicilio e dell'assistenza continuativa." },
  { year: "2026", text: "Oltre quarant'anni di esperienza nel settore: un centro di riferimento riconosciuto." },
];

export const CHANNELS = [
  { id: "farmacie", title: "Farmacie", desc: "Supporto nella disponibilità di calze, dispositivi compressivi e prodotti specialistici, con informazioni tecniche e indicazioni per una corretta gestione delle richieste del cliente." },
  { id: "sanitarie", title: "Sanitarie e ortopedie", desc: "Una gamma articolata di prodotti LUMAVEN e SCHIEBLER, bendaggi e altre soluzioni, accompagnata da supporto tecnico-informativo nella gestione di modelli, misure ed esecuzioni." },
  { id: "distributori", title: "Distributori farmaceutici", desc: "Collaborazione con gli operatori della distribuzione intermedia farmaceutica che riforniscono farmacie e canali sanitari specializzati, con una gestione organizzata di ordini, disponibilità e forniture." },
  { id: "medici", title: "Medici specialisti", desc: "Un riferimento informativo per flebologi, angiologi, chirurghi vascolari e altri specialisti coinvolti nei percorsi di terapia elasto-compressiva, nel pieno rispetto delle competenze cliniche." },
  { id: "strutture", title: "Strutture sanitarie", desc: "Forniture dedicate a ospedali, cliniche, RSA e strutture assistenziali, con soluzioni comprendenti calze antitrombo, bendaggi, sistemi di pressoterapia e altri dispositivi specialistici." },
  { id: "pazienti", title: "Pazienti", desc: "Misurazione professionale, prova della calza e assistenza in sede o a domicilio, nel rispetto della prescrizione ricevuta e delle indicazioni del personale sanitario." },
];

export const COMPANY_INTRO = [
  "L'esperienza di Medisistem nel settore nasce nel 1986 e diventa un'azienda nel 1992: da allora siamo specializzati nella terapia elasto-compressiva e nella distribuzione di dispositivi medicali dedicati alla prevenzione e al trattamento delle patologie venose e linfatiche.",
  "Da oltre quarant'anni affianchiamo medici specialisti, farmacie, sanitarie, ortopedie, strutture sanitarie e pazienti, offrendo prodotti selezionati, consulenza qualificata e servizi ad alto valore aggiunto.",
  "Crediamo che la qualità di un dispositivo medicale sia fondamentale, ma che il suo reale beneficio dipenda anche dalla competenza con cui viene consigliato, misurato e applicato.",
  "Per questo il nostro obiettivo non è semplicemente distribuire prodotti, ma accompagnare ogni cliente nella scelta della soluzione più adatta, garantendo professionalità, sicurezza ed efficacia terapeutica.",
];

export const HOME_ABOUT = "Da oltre quarant'anni accompagniamo professionisti sanitari e pazienti nella scelta delle migliori soluzioni per la terapia elasto-compressiva, offrendo prodotti di qualità, consulenza specialistica e un servizio di misurazione professionale che garantisce comfort, efficacia terapeutica e sicurezza.";

export const SCHIEBLER_INTRO = {
  title: "Distributore esclusivo per l'Italia",
  paragraphs: [
    "Medisistem è il distributore esclusivo per il mercato italiano dei prodotti SCHIEBLER, storico marchio tedesco riconosciuto a livello internazionale per l'eccellenza nella terapia elasto-compressiva.",
    "Grazie a questa partnership, Medisistem garantisce ai propri clienti un accesso diretto ai prodotti SCHIEBLER, assicurando competenza tecnica, consulenza specializzata e un supporto qualificato nella scelta della soluzione più adatta.",
  ],
};

export const MISSION = "Offriamo soluzioni professionali per la terapia elasto-compressiva, selezionando i migliori dispositivi medicali e affiancando professionisti sanitari e pazienti con consulenza qualificata, servizi personalizzati e un'assistenza orientata al benessere della persona.";

export const VISION = "Diventare il punto di riferimento nazionale nella terapia elasto-compressiva, distinguendoci per competenza, qualità dei prodotti, innovazione e servizi che migliorano concretamente l'esperienza del paziente e il lavoro dei professionisti sanitari.";

export const METHOD_BENEFITS = [
  "Corretta vestibilità",
  "Maggiore efficacia della terapia",
  "Più comfort nella vita quotidiana",
  "Riduzione dei resi e delle sostituzioni",
  "Maggiore soddisfazione del paziente",
  "Fiducia nel trattamento e nel prodotto",
];

export const PRODUCT_GROUPS = [
  {
    id: "lumaven",
    anchor: "prod-lumaven",
    to: "/prodotti/lumaven",
    name: "LUMAVEN",
    logo: "/brands/lumaven.png",
    badge: "Marchio di Proprietà Medisistem",
    theme: "green",
    intro: "La linea di proprietà Medisistem per la prevenzione e la profilassi antitrombo.",
    items: [
      {
        id: "lum-prev",
        name: "Calze Preventive",
        img: IMG.lumaven,
        short: "Sostegno leggero e discreto per l'uso quotidiano.",
        desc: "Pensate per chi lavora a lungo in piedi o seduto, per la gravidanza e per i viaggi. Un aiuto costante alla circolazione, senza rinunciare al comfort e all'eleganza.",
        specs: ["Compressione leggera graduata", "Prevenzione del ristagno venoso", "Tessuto traspirante e confortevole", "Vestibilità discreta"],
      },
      {
        id: "lum-anti",
        name: "Calze Antitrombo",
        img: IMG.antitrombo,
        short: "Profilassi antitromboembolica in ospedale e a domicilio.",
        desc: "Dispositivi per la prevenzione della trombosi venosa profonda nel paziente allettato e nel percorso post-operatorio, con apertura ispettiva sul piede.",
        specs: ["Prevenzione TVP", "Apertura ispettiva sul piede", "Compressione decrescente", "Uso ospedaliero e domiciliare"],
      },
    ],
  },
  {
    id: "schiebler",
    anchor: "prod-schiebler",
    to: "/prodotti/schiebler",
    name: "SCHIEBLER",
    logo: "/brands/schiebler.png",
    badge: "Distributore Esclusivo per l'Italia",
    ral: true,
    theme: "navy",
    intro: "L'eccellenza tedesca della calzetteria terapeutica, con marchio di qualità RAL.",
    items: [
      {
        id: "sch-start",
        name: "STAR COTTON",
        img: IMG.schiebler,
        badge: "Prodotto Principale",
        short: "La calza curativa in cotone, comfort per la pelle sensibile.",
        desc: "Massimo comfort a contatto con la pelle grazie alla fibra di cotone naturale: ideale per l'uso prolungato e per chi ha pelli sensibili.",
        specs: ["Fibra di cotone naturale", "Elevata traspirabilità", "Classi di compressione certificate", "Marchio RAL"],
      },
      {
        id: "sch-gold",
        name: "GOLDPUNKT KARAT",
        img: IMG.goldpunkt,
        badge: "Prodotto Principale",
        short: "La linea di riferimento SCHIEBLER, precisione e durata.",
        desc: "Precisione tedesca e durata nel tempo per la terapia quotidiana, con vestibilità anatomica ed estetica curata.",
        specs: ["Vestibilità anatomica", "Elevata resa terapeutica", "Estetica curata", "Marchio RAL"],
      },
      {
        id: "sch-doktus",
        name: "DOKTUS",
        img: IMG.doktus,
        badge: "Prodotto Principale",
        short: "Precisione terapeutica per i quadri clinici impegnativi.",
        desc: "Compressione graduata affidabile per le situazioni cliniche più complesse, con supporto specifico per il linfedema.",
        specs: ["Compressione graduata precisa", "Supporto linfedema", "Materiali resistenti", "Marchio RAL"],
      },
    ],
  },
  {
    id: "bendaggi",
    anchor: "prod-bendaggi",
    to: "/prodotti/bendaggi",
    name: "Bendaggi",
    badge: "Terapia compressiva",
    theme: "navy",
    intro: "Bende per la terapia compressiva e il supporto, in diverse tipologie a seconda della fase di trattamento.",
    items: [
      {
        id: "bend-adesivi",
        name: "Bende adesive",
        img: IMG.fabric,
        short: "Supporto muscolare, tendineo e articolare con fissaggio adesivo poroso.",
      },
      {
        id: "bend-coesivi",
        name: "Bende coesive",
        img: IMG.fabric,
        short: "Antiscivolo, per la fase di decongestione della terapia compressiva.",
      },
      {
        id: "bend-nonadesivi",
        name: "Bende non adesive",
        img: IMG.fabric,
        short: "Elasticità corta, media e forte per compressione e ortopedia.",
      },
    ],
  },
  {
    id: "pressoterapia",
    anchor: "prod-pressoterapia",
    to: "/prodotti/pressoterapia",
    name: "Pressoterapia",
    badge: "Pressoterapia Medicale",
    theme: "navy",
    intro: "Sistemi di pressoterapia per il drenaggio linfatico sequenziale degli arti.",
    items: [
      {
        id: "presso-advance",
        name: "Pressoterapia elettronica ADVANCE",
        img: IMG.pressotherapy,
        badge: "Modello di punta",
        short: "Pressoterapia elettronica a 4 uscite con programmi sequenziali A/B.",
      },
    ],
  },
];

// Terza mini-domanda condivisa: suggerisce la classe di compressione consigliata.
// Mostrata solo sui percorsi "calze" (prevenire + curare).
const SYMPTOM_STEP = {
  question: "Quanto sono marcati i tuoi sintomi?",
  options: [
    {
      id: "lievi",
      label: "Lievi — gambe pesanti o gonfiore a fine giornata",
      compressionClass: { level: "Classe 1", desc: "Compressione leggera: sostegno e prevenzione per l'uso quotidiano." },
    },
    {
      id: "moderati",
      label: "Moderati — vene evidenti o gonfiore frequente",
      compressionClass: { level: "Classe 2", desc: "Compressione media: la più utilizzata nel trattamento terapeutico." },
    },
    {
      id: "importanti",
      label: "Importanti — alterazioni cutanee o linfedema",
      compressionClass: { level: "Classe 3", desc: "Compressione forte: per i quadri clinici più impegnativi." },
    },
  ],
};

export const PRODUCT_QUIZ = {
  question: "Qual è la tua esigenza principale?",
  options: [
    {
      id: "prevenire",
      label: "Prevenire gambe pesanti e gonfie",
      result: { brand: "LUMAVEN", name: "Calze Preventive", desc: "Sostegno leggero e discreto per l'uso quotidiano, ideale per chi sta molte ore in piedi o seduto.", to: "/prodotti/lumaven" },
      next: SYMPTOM_STEP,
    },
    {
      id: "curare",
      label: "Curare un problema venoso o linfatico",
      next: {
        question: "Che tipo di calza preferisci?",
        options: [
          { id: "cotone", label: "Comoda, in cotone (pelle sensibile)", result: { brand: "SCHIEBLER", name: "STAR COTTON", desc: "Calza curativa in cotone: massimo comfort per l'uso prolungato e le pelli sensibili.", to: "/prodotti/schiebler/star-cotton" }, next: SYMPTOM_STEP },
          { id: "quotidiana", label: "Di riferimento per l'uso quotidiano", result: { brand: "SCHIEBLER", name: "GOLDPUNKT KARAT", desc: "La linea di riferimento SCHIEBLER: precisione, durata e vestibilità anatomica.", to: "/prodotti/schiebler/goldpunkt-karat" }, next: SYMPTOM_STEP },
          { id: "impegnativo", label: "Per casi impegnativi o linfedema", result: { brand: "SCHIEBLER", name: "DOKTUS", desc: "Compressione graduata precisa per i quadri clinici più complessi e il linfedema.", to: "/prodotti/schiebler/doktus" }, next: SYMPTOM_STEP },
        ],
      },
    },
    {
      id: "trombosi",
      label: "Prevenire la trombosi (ricovero o operazione)",
      result: { brand: "LUMAVEN", name: "Calze Antitrombo", desc: "Profilassi antitromboembolica per il paziente allettato e nel percorso post-operatorio.", to: "/prodotti/lumaven" },
    },
    {
      id: "bendaggio",
      label: "Mi serve un bendaggio o la pressoterapia",
      next: {
        question: "Quale trattamento ti occorre?",
        options: [
          { id: "benda", label: "Bendaggio elastico", result: { brand: "Bendaggi", name: "Bendaggi", desc: "Bende a corta e lunga estensibilità per la fase intensiva del trattamento decongestivo.", to: "/prodotti/bendaggi" } },
          { id: "presso", label: "Pressoterapia / drenaggio", result: { brand: "Pressoterapia", name: "Pressoterapia ADVANCE", desc: "Drenaggio linfatico sequenziale con controllo digitale della pressione, 4 uscite e touch screen.", to: "/prodotti/pressoterapia" } },
        ],
      },
    },
  ],
};

export const CONTACT_REASONS = [
  "Informazioni prodotti",
  "Misurazione",
  "Servizio a domicilio",
  "Info professionali",
  "Altro",
];

// Testi UI condivisi (non presenti nelle strutture dati)
export const COPY = {
  nav: { ctaBooking: "Prenota Misurazione", language: "Lingua" },
  langNames: { it: "Italiano", en: "English" },
  ui: {
    allProducts: "← Tutti i prodotti",
    immediateAvailability: "Disponibilità immediata",
    discover: "Scopri",
    discoverProducts: "Scopri i prodotti",
    discoverBrand: "Scopri",
    mostChosen: "La più scelta",
    brandsEyebrow: "I nostri marchi",
    payoff: "Affidabilità che si indossa.",
    seeAllProducts: "Vedi tutti i nostri prodotti",
    ctaEyebrow: "Prenota ora",
    ctaTitle: "La misura giusta inizia da un incontro.",
    ctaText: "Prenota la tua misurazione professionale, in sede o a domicilio. Ti seguiamo passo dopo passo.",
    ctaBook: "Prenota Misurazione",
    ctaMethod: "Scopri il Metodo",
    solutionsCount: "Cinque",
    solutionsLabel: "soluzioni",
    complementDivider: "A completamento della terapia",
    testimonialsEyebrow: "Recensioni",
    testimonialsTitle: "La fiducia dei nostri pazienti.",
    testimonialsIntro: "Storie di chi ha scelto una misurazione professionale e ne ha sentito la differenza.",
    productDiscover: "Scopri il prodotto",
    goToPage: "Vai alla pagina",
    filtersLabel: "Filtra per soluzione",
    photoSoon: "Foto in arrivo",
    brandLabel: "Marchio",
    noProducts: "Nessun prodotto in questa categoria al momento.",
    requestTitle: "Nessun prezzo online, solo la scelta giusta.",
    requestText: "Contattaci per una consulenza dedicata e la misurazione professionale.",
    requestCta: "Richiedi informazioni",
    finderEyebrow: "Trova il prodotto giusto",
    finderRestart: "Ricomincia",
    finderQuestion: "Domanda",
    finderHint: "Scegli la risposta più vicina alla tua situazione.",
    finderWeRecommend: "Ti consigliamo",
    finderSeeProduct: "Vedi il prodotto",
    finderClassTitle: "Classe di compressione consigliata",
    finderClassNote: "Indicazione orientativa: la classe definitiva viene confermata dallo specialista in fase di misurazione.",
  },
};
